// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --gutter: 2.4rem;
    --color-neutrals-background-zebra: rgba(0,0,0,0.05);
    --color-neutrals-borderBeta: rgba(0,0,0,0.1);
    --border-radius-large: 1.6rem;
}

.oVFon2q9oQBxMa5Wn6pg {
    border: 0.2rem solid var(--color-neutrals-borderBeta);
    border-radius: var(--border-radius-large);
    list-style: none;
    padding: 0;
    overflow: hidden;
    font-size: 1.6rem;
}

.oVFon2q9oQBxMa5Wn6pg > li {
    min-height: 7rem;
    display: flex;
    align-items: center;
}

.oVFon2q9oQBxMa5Wn6pg > li > * {
    flex: 1;
}

.oVFon2q9oQBxMa5Wn6pg > li + li {
    border-radius: 0 !important;
    border-top: 0.2rem solid var(--color-neutrals-borderBeta);
}

.oVFon2q9oQBxMa5Wn6pg.cigRlXwWjYDdJSCBFHv0 {
    padding-top: calc(var(--gutter) / 2);
    padding-bottom: calc(var(--gutter) / 2);
}

.oVFon2q9oQBxMa5Wn6pg.cigRlXwWjYDdJSCBFHv0 > li {
    min-height: 4rem;
}

.oVFon2q9oQBxMa5Wn6pg.cigRlXwWjYDdJSCBFHv0 > li + li {
    border-top: none;
}

.oVFon2q9oQBxMa5Wn6pg.WvyvS1DlIHnm2aJ8shTp > li {
    padding: calc(var(--gutter) / 3) calc(var(--gutter));
    min-height: 0;
}

.oVFon2q9oQBxMa5Wn6pg.hXPlh2g6HbSGZWBFX5sp > li:nth-child(even) {
    background: var(--color-neutrals-background-zebra);
}

.QMkjDmxvtlvf8_rGBRA6 {
    border: 0.2rem solid var(--color-neutrals-borderBeta);
}

.QMkjDmxvtlvf8_rGBRA6 .oVFon2q9oQBxMa5Wn6pg {
    border-radius: 0 !important;
    border-left: none;
    border-right: none;
}

.QMkjDmxvtlvf8_rGBRA6 .oVFon2q9oQBxMa5Wn6pg:last-child {
    border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./pages/Organizations/EnterpriseMemberDetails/MemberLogs/style.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mDAAmD;IACnD,4CAA4C;IAC5C,6BAA6B;AACjC;;AAEA;IACI,qDAAqD;IACrD,yCAAyC;IACzC,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,2BAA2B;IAC3B,yDAAyD;AAC7D;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oDAAoD;IACpD,aAAa;AACjB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[":root {\n    --gutter: 2.4rem;\n    --color-neutrals-background-zebra: rgba(0,0,0,0.05);\n    --color-neutrals-borderBeta: rgba(0,0,0,0.1);\n    --border-radius-large: 1.6rem;\n}\n\n.table {\n    border: 0.2rem solid var(--color-neutrals-borderBeta);\n    border-radius: var(--border-radius-large);\n    list-style: none;\n    padding: 0;\n    overflow: hidden;\n    font-size: 1.6rem;\n}\n\n.table > li {\n    min-height: 7rem;\n    display: flex;\n    align-items: center;\n}\n\n.table > li > * {\n    flex: 1;\n}\n\n.table > li + li {\n    border-radius: 0 !important;\n    border-top: 0.2rem solid var(--color-neutrals-borderBeta);\n}\n\n.table.borderless {\n    padding-top: calc(var(--gutter) / 2);\n    padding-bottom: calc(var(--gutter) / 2);\n}\n\n.table.borderless > li {\n    min-height: 4rem;\n}\n\n.table.borderless > li + li {\n    border-top: none;\n}\n\n.table.compact > li {\n    padding: calc(var(--gutter) / 3) calc(var(--gutter));\n    min-height: 0;\n}\n\n.table.zebra > li:nth-child(even) {\n    background: var(--color-neutrals-background-zebra);\n}\n\n.tableWrapper {\n    border: 0.2rem solid var(--color-neutrals-borderBeta);\n}\n\n.tableWrapper .table {\n    border-radius: 0 !important;\n    border-left: none;\n    border-right: none;\n}\n\n.tableWrapper .table:last-child {\n    border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
export var table = `oVFon2q9oQBxMa5Wn6pg`;
export var borderless = `cigRlXwWjYDdJSCBFHv0`;
export var compact = `WvyvS1DlIHnm2aJ8shTp`;
export var zebra = `hXPlh2g6HbSGZWBFX5sp`;
export var tableWrapper = `QMkjDmxvtlvf8_rGBRA6`;
export default ___CSS_LOADER_EXPORT___;
